import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=1cb9c1ce&scoped=true&"
import script from "./ProjectsPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9c1ce",
  null
  
)

export default component.exports